import * as Const from '../constants/actionConstants';

import State from '../interfaces/states/SubFormSendState';

const initState: State = {
  finishedForm: {},
  isSending: false,
  isSuccess: false,
  error: null,
};

export default function subFormSend (state: State = initState, action): State {
  switch (action.type) {

    case Const.SUB_FORM_IS_SENDING:
      return {
        ...state,
        isSending: true,
      };

    case Const.SUB_FORM_NOT_SEND:
      return {
        ...state,
        isSending: false,
      };

    case Const.SUB_FORM_FINISHED_FORM:
      return {
        ...state,
        finishedForm: action.finishedForm,
      };

    case Const.SUB_FORM_IS_SUCCESS:
      return {
        ...state,
        isSending: false,
        isSuccess: true,
      };

    default:
      return state;
  }
}
